import ReactDOM from 'react-dom';
import { FaqSection } from '../components/FaqSection';
import { initializeI18n } from '../localization/i18n';

window.renderFaqSection = (elementId, props) => {
  const container = document.getElementById(elementId);
  if (container) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<FaqSection props={props} />, container);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering FaqSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
